import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

const mapStateToProps = state => { 
    const urls = state.indexUrls;
    return { urls };
};

const StyledIndex = styled.div`
    height: 100px;
    padding: 40px;

    @media screen and (max-width: 600px) {
        padding: 15px;
    }
`;

const Paragraph = styled.div`
    font-size: 18px;
    font-weight: normal;
    line-height: 24px;
    margin: 15px 0;
`;

const Link = styled.a`
    border-bottom: 2px solid transparent;
    color: ${props => props.theme.content.color};
    border-color: ${props => props.theme.content.color};
    font-weight: 700;
    text-decoration: none;
    transition: color 200ms ease-in, border-color 200ms ease-in;

    &:hover {
        border-color: ${props => props.theme.content.hoverColor};
        color: ${props => props.theme.content.hoverColor};
        text-decoration: none;
    }
`;

const Italiced = styled.span`
    font-style: italic;
`;

const Index = ({ urls }) => {
    const transitionTime = 400;
    const [inProp, setInProps] = useState(false);

    useEffect(() => {
        setInProps(true);
        return () => setInProps(false)
    }, []);

    return (
        <CSSTransition
            in={inProp}
            timeout={{ enter: transitionTime, exit: transitionTime }}
            unmountOnExit
            classNames="s-gdpr__effect"
        >
            <StyledIndex>

                <Paragraph>
                    Ние събираме и обработваме Вашите лични данни.
                </Paragraph>

                <Paragraph>
                    За осигуряване на правата ви по GDPR, молим за Вашето съгласие.
                </Paragraph>

                <Paragraph>
                    Ще използваме данните за осигуряване на по-доброто Ви преживяване на нашите сайтове.
                </Paragraph>

                <Paragraph>
                    Ако натиснете бутона <Italiced> Приемам всички</Italiced>, ще дадете съгласието си на нас и на всички трети страни, описани детайлно в
                    <Link href={urls[0]} > Политиката за поверителност</Link> и
                    <Link href={urls[1]}> Политиката за бисквитките</Link>.
                </Paragraph>

                <Paragraph>
                    <Link href={urls[2]}>
                        Защо е необходимо моето съгласие?
                    </Link>
                </Paragraph>

            </StyledIndex>
        </CSSTransition>
    )
}

export default connect(mapStateToProps)(Index);